export { PagesRendererDirective, CarouselPage } from './render.component';

import {
  Component, Input, Output, EventEmitter, ContentChild, ContentChildren, ElementRef, OnInit
} from '@angular/core';
import { map, catchError } from 'rxjs/operators';

import { PagesRendererDirective, CarouselPage } from './render.component';
import { DotIndicatorComponent } from './dotindicator.component';
import { NavButtonComponent } from './navbutton.component';
import { PageSliderControlAPI } from './types';
import { SlideAnimation } from './events/animation';

import { SideClickHandler } from './events/sideclick';
import { TouchEventHandler } from './events/touchevents';
import { ArrowKeysHandler } from './events/arrowkeys';


// PAGE CONTAINER DIRECTIVE =================================================================
// Handles fancy things like page animation and controls KBPagesRendererDirective

@Component({
  selector: 'app-page-slider',
  template: `
		<!-- Display the actual pages -->
	<div  [style.height]='containerHeight' class='outer-box'>
	<div class='buttons' *ngIf='buttons.length > 0' [style.top]='buttonTop'>
			<!-- Display navigation buttons -->
			<ng-content select='app-nav-button[backward]'></ng-content>
		</div>
		<div class='inner'
				[style.width]='containerWidth'
				[style.height]='containerHeight'>
      <ng-content></ng-content>
    </div>

</div>
	`,
  styleUrls: ['./pageslider.component.scss']
})

export class PageSliderComponent implements PageSliderControlAPI, OnInit {

  private innerContainer: HTMLElement;
  private touchEventHandler: TouchEventHandler;
  private sideClickHandler: SideClickHandler;
  private arrowKeysHandler: ArrowKeysHandler;
  private blockInteraction = false;
  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<[number, number]>();
  @Output() pageCountChange = new EventEmitter<number>();

  //slide data to get aria-labels for nav button
  @Input() data: any;

  // Dot Indicator
  @Input() public showIndicator = true;
  @Input() public overlayIndicator = true;
  @Input() public dotColor = 'white';
  @Input() public pageIndex = 0;
  public dotTransitionInProgress = false;
  // Interactivity
  @Input() public locked = false;
  @Input() public transitionDuration: number;
  @Input() public transitionInterval: number;
  @Input() public enableOverscroll = true;
  @Input() public set enableSideClicks(enabled: boolean) {
    (this.sideClickHandler) ? this.sideClickHandler.enabled = enabled : null;
  }
  @Input() public set enableArrowKeys(enabled: boolean) {
    (this.arrowKeysHandler) ? this.arrowKeysHandler.enabled = enabled : null;
  }

  @Output() scrollStateChange = new EventEmitter<boolean>();

  private transitionIntervalFunc: any;
  private _pageOffset = 1;

  //TODO fix for UPGRADE
  @ContentChildren(NavButtonComponent)
  //@ContentChildren('buttons', {static: false})
  buttons;

  @ContentChild(PagesRendererDirective,
    /* TODO: add static flag */ { static: true })
  //@ContentChildren('renderer', {static: false})
  renderer: PagesRendererDirective;

  constructor(
    private element: ElementRef
  ) {
    const htmlElement = this.element.nativeElement;

    this.touchEventHandler = new TouchEventHandler(this, htmlElement);
    this.sideClickHandler = new SideClickHandler(this, htmlElement);
    this.arrowKeysHandler = new ArrowKeysHandler(this, htmlElement);
  }


  // PUBLIC INTERFACE =====================================================================

  @Input() public set page(pn: number) {
    let animateVar = null;
    if (pn < 0 || pn >= this.pageCount) { return; }
    if (pn === this.renderer.page) { return; }
    if (this.renderer) {
      if (pn > this.renderer.page) {
        if (this.blockInteraction) { return; }
        animateVar = ((pn - this.renderer.page) + 1);
        this.pageIndex = pn;
        this.AnimateToNextPage(null, animateVar, pn);
      } else if (pn < this.renderer.page && (this.dotTransitionInProgress ||
        !(pn === 0 && (this.renderer.page === (this.pageCount - 1))))) {
        if (this.blockInteraction) { return; }
        animateVar = ((pn - this.renderer.page) + 1);
        this.pageIndex = pn;
        this.AnimateToPreviousPage(null, animateVar, pn);
        this.dotTransitionInProgress = false;
      } else if (pn === 0 && (this.renderer.page === (this.pageCount - 1))) { /** Condition added for transition of last slide*/
        if (this.blockInteraction) { return; }
        this.pageIndex = pn;
        this.renderer.prepareLastPageAnimation();
        this.AnimateToFirstPage();
      } else {
        if (this.blockInteraction) { return; }
        this.renderer.page = pn;
        this.pageIndex = pn;
        this.pageChange.emit(pn);
      }
    }
  }

  public get page() { return (this.renderer) ? this.renderer.page : 0; }
  public get pageCount() { return (this.renderer) ? this.renderer.pageCount : 0; }









  // INTERNAL STATE =======================================================================

  protected get pageOffset() { return this._pageOffset; }
  protected set pageOffset(v: number) {
    this._pageOffset = v;
    if (!this.blockInteraction) {
      this.innerContainer.style.left = this.pxOffset;
    }
  }
  private get pxOffset() { return -this.pageOffset * this.pageWidth + 'px'; }


  // NAV BUTTONS

  public get buttonTop() {
    return this.pageHeight / 2 - (this.buttons.first.size / 2) - 30 + 'px';
  }


  // SIZING

  public get pageWidth() { return this.element.nativeElement.offsetWidth; }

  public get pageHeight() {
    const fullHeight = this.element.nativeElement.offsetHeight;
    return fullHeight; // - chin;
  }


  public get containerWidth() { return this.pageWidth * 3 + 'px'; }
  public get containerHeight() { return this.pageHeight + 'px'; }
  ;
  public get dotBottom() { return (this.overlayIndicator) ? '11px' : '0px'; }

  // Get the page renderer loop and keep its size up to date
  ngOnInit() {
    if (!this.renderer) {
      throw new Error('No *kbPages directive found inside kb-page-slider');
    }

    this.renderer.pageCountChange.subscribe((count) => {
      this.pageCountChange.emit(count);
    });
    this.Resize();
    this.renderer.Resize(this.pageWidth, this.pageHeight);
    window.addEventListener('resize', () => {
      this.Resize();
      this.renderer.Resize(this.pageWidth, this.pageHeight);
      this.pageSizeChange.emit([this.pageWidth, this.pageHeight]);
    });
    // if (this.transitionInterval) {
    //   this.autoAnimate();
    // }
  }


  protected Resize() {
    this.innerContainer = this.element.nativeElement.querySelector('.inner');
    this.innerContainer.style.left = -this.pageWidth + 'px';
  }

  private updatePage(index) {
    if (this.locked || this.blockInteraction) { return; }
    if (this.page === index) { return; }
    this.dotTransitionInProgress = true;
    this.page = index;
    this.stopAutoTransition();
  }

  /** Method to stop auto animation */
  public stopAutoTransition() {
    clearInterval(this.transitionIntervalFunc);
  }

  /** Method to start auto animation */
  // public startAutoTransition() {
  //   this.autoAnimate();
  // }


  private autoAnimate() {
    if (this.locked || this.blockInteraction) { return; }
    if (this.page < (this.pageCount - 1)) {
      this.page++;
    } else {
      this.page = 0;
    }
    this.transitionIntervalFunc = setInterval(() => {
      if (this.page < (this.pageCount - 1)) {
        this.page++;
      } else {
        this.page = 0;
      }
    }, this.transitionInterval);
  }

  // INTERACTIVE NAVIGATION ===============================================================



  public ScrollTo(x: number) {
    // if (this.locked || this.blockInteraction) { return; }
    // this.pageOffset = this.ClampX(x);
  }

  public AnimateToNextPage(momentum?: number, animateNum?: number, pn?: number) {
    if (this.locked || this.blockInteraction) { return; }
    if (this.page === this.renderer.pageCount - 1) {
      return this.AnimateToX(1, 0).then(() => { this.pageOffset = 1; });
    }
    if (momentum === undefined) { momentum = 0; }
    if (animateNum === undefined) { animateNum = 2; }

    this.AnimateToX(animateNum, momentum).then(() => {
      if (pn !== undefined) {
        this.renderer.page = pn;
      } else {
        const pgIdx = this.renderer.page + 1;
        this.pageIndex = pgIdx;
        this.renderer.page = pgIdx;
      }
      this.pageChange.emit(this.renderer.page);
      this.pageOffset = 1;
    });
  }

  /**Method added for last page animation to first page */
  public AnimateToFirstPage() {
    // if (this.locked || this.blockInteraction) { return; }
    // this.AnimateToX(2, 0).then(() => {
    //   this.pageOffset = 1;
    //   this.renderer.page = 0;
    //   this.pageChange.emit(this.renderer.page);
    // });
  }

  public AnimateToPreviousPage(momentum?: number, animateNum?: number, pn?: number) {
    // if (this.locked || this.blockInteraction) { return; }
    // if (this.page === 0) {
    //   return this.AnimateToX(1, 0).then(() => { this.pageOffset = 1; });
    // }
    // if (momentum === undefined) { momentum = 0; }
    // if (animateNum === undefined) { animateNum = 0; }

    // this.AnimateToX(animateNum, momentum).then(() => {
    //   if (pn !== undefined) {
    //     this.renderer.page = pn;
    //   } else {
    //     const pgIdx = this.renderer.page - 1;
    //     this.pageIndex = pgIdx;
    //     this.renderer.page = pgIdx;
    //   }
    //   this.pageChange.emit(this.renderer.page);
    //   this.pageOffset = 1;
    // });
  }

  public AnimateToX(x: number, momentum: number) {
    if (this.locked || this.blockInteraction) { return; }
    this.blockInteraction = true;

    const w = this.pageWidth;
    return new SlideAnimation(
      this.innerContainer,	 	// Element to animate
      -this.pageOffset * w,		// Current position (px)
      -x * w,	 					// Destination position (px)
      momentum * w,			 	// User scroll momentum (px/s)
      this.transitionDuration		// Default duration, when momentum = 0
    ).then(() => {
      this.blockInteraction = false;
    });
  }

  public StartScroll() {
    //  this.scrollStateChange.emit(true);
  }
  public EndScroll() {
    // this.scrollStateChange.emit(false); 
  }

  // OVERSCROLL (iOS STYLE) ===============================================================

  // Get X to a reasonable range, taking into account page boundaries
  protected ClampX(x: number) {
    // if (x < 0) { x = 0; }
    // if (x > 2) { x = 2; }

    // Allow some over scrolling on the first and last page
    // if (this.page === 0 && x < 1) {
    //   if (this.enableOverscroll) {
    //     x = 1 - this.OverscrollRamp(1 - x);
    //   } else {
    //     x = 1;
    //   }
    // }
    // if (this.page === this.renderer.pageCount - 1 && x > 1) {
    //   if (this.enableOverscroll) {
    //     x = 1 + this.OverscrollRamp(x - 1);
    //   } else {
    //     x = 1;
    //   }
    // }
    // return x;
  }

  // Exponential ramp to simulate elastic pressure on over scrolling
  protected OverscrollRamp(input: number): number {
    return Math.pow(input, 0.5) / 5;
  }
}
